import { render, staticRenderFns } from "./SensorVirtualPeriodoUltimasHoras.vue?vue&type=template&id=52c3db2b&scoped=true&"
import script from "./SensorVirtualPeriodoUltimasHoras.vue?vue&type=script&lang=js&"
export * from "./SensorVirtualPeriodoUltimasHoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c3db2b",
  null
  
)

export default component.exports